module.exports = __webpack_public_path__ + "img/chips50000.36ec3d6a.webp";